/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function ArrowLeftIcon({ className, size = 'xsmall' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color: 'primary',
      }}
      className={className}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M.146 9.146l4-4a.5.5 0 01.707.707L1.707 9H19.5a.5.5 0 110 1H1.707l3.146 3.146a.5.5 0 01-.707.707l-4-4a.5.5 0 010-.707"
      ></path>
    </svg>
  );
}
